(() => {
  const updateJoyButtonName = () => {
    const button = document.getElementById("Avada-Joy_FloatingButtonTrigger");
    const visibleLabel = button?.textContent.trim();

    if (!button || !visibleLabel) return false;

    button.setAttribute("aria-label", `${visibleLabel} - open loyalty program`);
    return true;
  };

  if (updateJoyButtonName()) return;

  const observer = new MutationObserver(() => {
    if (updateJoyButtonName()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.setTimeout(() => observer.disconnect(), 15000);
})();
